import { ChangeDetectorRef, Component, Injector, OnInit } from '@angular/core';
import { DevicesClass } from '@app/core/classes';
import { RoutingConfig } from '@app/routing/routing.config';
import { DialogIncludesTypes } from '@app/core/models/diallog';
import { NotificationService } from '@app/modules/notification-modules/notification.service';

@Component({
  selector: 'shared-page-footer',
  templateUrl: 'page-footer.component.html',
  styleUrls: [`./page-footer.component.scss`],
})

export class PageFooterComponent extends DevicesClass implements OnInit {
  public Routing = RoutingConfig;

  constructor(injector: Injector,
    public cdr: ChangeDetectorRef,
    private notificationService: NotificationService
  ) {
    super(injector);
  }

  ngOnInit(): void {
  }

  onTeaserIOS(): void {
    this.notificationService.onDialog({
      type: DialogIncludesTypes.PopupTemplate,
      header: 'App Store',
      content: 'Мы работаем над ним =)',
      icons: 'pi pi-apple'
    });
  }

  onTeaserAndroid(): void {
    this.notificationService.onDialog({
      type: DialogIncludesTypes.PopupTemplate,
      header: 'Google Play',
      content: 'Мы работаем над ним =)',
      icons: 'pi pi-android\n'
    });
  }
}
